import { ApiDefinition } from "./ApiDefinition";
import { APIPromise } from "../services/HttpService";
import { CreateDatasetGroup, DatasetGroup } from "./model/dataset/datasetGroups";

class DatasetGroupsApiDefinition extends ApiDefinition {
  constructor() {
    super("/dataset-groups");
  }

  async getAll(): APIPromise<DatasetGroup[]> {
    return this.get("all-root");
  }

  async getById(id: number): APIPromise<DatasetGroup> {
    return this.get(`${id}`);
  }  

  async create(data: CreateDatasetGroup): APIPromise<DatasetGroup> {
    return this.post(null, data);
  }

  async update(id: number, data: DatasetGroup): APIPromise<DatasetGroup> {
    return this.put(`${id}`, data);
  }
  
  async remove(id: number): APIPromise<DatasetGroup> {
    return this.delete(`${id}`);
  }
}

const DatasetGroupsApi = new DatasetGroupsApiDefinition();

export default DatasetGroupsApi;
